import { Layout } from '@components/common'
import { Container, Heading2 } from '@components/ui'
import { Grid, Column } from '@components/common'
import SEO from '@components/common/SEO/SEO'

export default function PrivacyPolicy() {
  return (
    <Container>
      {/* Using Grid to Add Top/Bottom Padding w/o Creating a New Component */}
      <Grid xsGutter={30}>
        <Column xs={12}>
          <Heading2>WE VALUE YOUR TRUST!</Heading2>
          <p>
            TS Pool Supply is committed to respecting and protecting your right
            to privacy and we take your privacy seriously. We have a strictly
            enforced privacy policy and will keep your personal information
            secure. To communicate this, we have created this privacy policy to
            disclose and describe our information gathering and dissemination
            practices for our online communications.
          </p>
          <Heading2>OUR PRIVACY POLICY EXPLAINS:</Heading2>
          <ul>
            <li>What information we collect</li>
            <li>How we use that information</li>
            <li>What information we share with our partners</li>
            <li>The choices we offer</li>
          </ul>
          <Heading2>COLLECTION OF YOUR PERSONAL INFORMATION</Heading2>
          <p>
            Most pages on this site can be viewed without providing any
            information about you. However, for some content we will request
            information that makes you personally identifiable. Your personal
            information is collected for internal use by TS Pool Supply for site
            traffic analysis, response to requests and occasional marketing
            communications. All personal information submitted to TS Pool Supply
            is done so voluntarily and with your consent. We pledge to hold all
            information you provide to us in absolute privacy. We will never
            sell or rent your name or personal information to any third party
            without your express permission. Only authorized employees may
            access your information.
          </p>
          <Heading2>HOW WE USE COOKIES</Heading2>
          <p>
            TS Pool Supply uses technologies such as cookies and pixels to keep
            track of your activities on our website and to serve you more
            relevant advertisements. A cookie is a small text file that is
            stored on your device for record-keeping purposes. Session cookies
            expire when you close your browser. Persistent cookies remain on
            your device for an extended period of time. We and our third party
            partners use session cookies and persistent cookies to make it
            easier for you to navigate and enhance the experience of our site,
            and to monitor and evaluate our website’s operation and use.
          </p>
          <p>
            As you browse TS Pool Supply, we may place anonymous cookies on your
            computer, and use similar technologies, in order to understand your
            interests based on your activity on our website, and thus to tailor
            more relevant ads to you. If you do not wish to receive such
            tailored advertising, you can visit this page
            (http://www.networkadvertising.org/managing/opt_out.asp ) to opt out
            of most companies that engage in such advertising. (This will not
            prevent you from seeing ads; the ads simply will not be delivered
            through these targeting methods.)
          </p>
          <Heading2>GOOGLE ADWORDS OR ADROLL REMARKETING</Heading2>
          <p>
            This website uses the Google AdWords and Adroll remarketing service
            to advertise on third party websites (including Google) to previous
            visitors to our site. It could mean that we advertise to previous
            visitors who haven’t completed a task on our site, for example using
            the contact form to make an inquiry. This could be in the form of an
            advertisement on the Google search results page, or a site in the
            Google Display Network. Third-party vendors, including Google, use
            cookies to serve ads based on someone’s past visits to the TS Pool
            Supply website. Of course, any data collected will be used in
            accordance with our own privacy policy and Google’s privacy policy.
          </p>
          <p>
            You can choose to opt out of being retargeted by our ads here:
            http://www.networkadvertising.org/managing/opt_out.asp
          </p>
          <Heading2>BUSINESS NEGOTIATIONS</Heading2>
          <p>
            We may contemplate, for strategic or other reasons, selling, buying,
            merging, or otherwise reorganizing one or more of our businesses. In
            negotiating with a third party about entering into such an
            arrangement, we may need to disclose your personal information. In
            such cases, we will take reasonable measures to protect the personal
            information we disclose, for example, by requiring a prospective
            purchaser to sign a non-disclosure agreement limiting the use and
            protecting the confidentiality of the personal information.
          </p>
          <Heading2>BUSINESS TRANSFERS</Heading2>
          <p>
            We may transfer the personal information you submit on or through
            our website to any organization that acquires or merges with one or
            more of our businesses.
          </p>
          <Heading2>CHANGES TO THIS PRIVACY POLICY</Heading2>
          <p>
            If we decide to change our privacy policy, we will post those
            changes to this privacy statement, the homepage, and other places we
            deem appropriate so that you are aware of what information we
            collect, how we use it, and under what circumstances, if any, we
            disclose it. TS Pool Supply reserves the right to modify this
            privacy statement at any time, so please review it frequently.
          </p>
          <Heading2>
            ENFORCEMENT OF THIS PRIVACY POLICY AND CONTACT INFORMATION
          </Heading2>
          <p>
            The TS Pool Supply website contains links to other websites. This
            privacy statement applies only to the TS Pool Supply website. Please
            review the privacy statement of any site before submitting your
            personally identifiable information.
          </p>
        </Column>
      </Grid>
      <SEO
        title={'Privacy Policy'}
        description={'Privacy policy for TS Pool Supply.'}
        openGraph={{
          type: 'website',
          title: 'Privacy Policy',
          description: 'TS Pool Supply privacy policy.',
          images: [
            {
              url: '/static_images/ts-pool-supply-og-pool.jpg',
              width: 1280,
              height: 720,
              alt: 'TS Pool Supply',
            },
          ],
        }}
      ></SEO>
    </Container>
  )
}

PrivacyPolicy.Layout = Layout
